// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ovse","title":"Info_title__3ZTe2","links":"Info_links__1GrMO","link":"Info_link__2uDwp","logo":"Info_logo__2cm2k"};